import { useMemo } from "react";
import { useWatch } from "react-hook-form";

import { useGetAttachmentBuckets } from "api/queries/common/useGetAttachmentBuckets";
import usePermissions from "hooks/usePermissions";

export function useAttachmentsData() {
  const location: string = useWatch({ name: "organizational.location" }) ?? "";
  const { parsedPermissions } = usePermissions();
  const hasAttachmentBuckets: boolean = parsedPermissions?.company_shipper_settings?.request_attachment_buckets ?? false;

  const { data: bucketAttachments = [], isLoading: isLoadingBuckets } = useGetAttachmentBuckets(location, true, {
    enabled: !!location,
    refetchOnMount: false,
  });

  return useMemo(
    () => ({
      bucketAttachments,
      isLoadingBuckets,
      hasAttachmentBuckets,
    }),
    [bucketAttachments, isLoadingBuckets, hasAttachmentBuckets],
  );
}
